<template>
    <span>Sorry man, you ain't authed!</span>
</template>
<script>
export default {
    
}
</script>